module.exports = __webpack_public_path__ + "icon-long.982825f3de3201dfb6491150aacc1805.png";